// deps
import React, { useState, memo } from "react";

// constants
import { CONSTANTS } from "@cart-ui/components/incognito-mode-widget/constants";

// styles
import { ScrollContainer, ScrollText, ScrollTextItem, Wrapper } from "./styles";

// test-ids
import { INCOGNITO_CART_DATA_TEST_IDS } from "@swiggy-private/cart-test-ids";

const VerticalScrollTextBanner = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleClick = () => {
        setCurrentIndex(prevIndex => (prevIndex + 1) % CONSTANTS.VERTICAL_SCROLL_BAR.SCROLL_TEXTS.length);
    };

    return (
        <Wrapper>
            <ScrollContainer data-testid={INCOGNITO_CART_DATA_TEST_IDS.TOP_BANNER.CONTAINER}>
                {CONSTANTS.VERTICAL_SCROLL_BAR.SCROLL_TEXTS.map((text, index) => (
                    <ScrollTextItem
                        className="scrolling-text-item"
                        key={index}
                        yPosition={currentIndex * 100}
                        onClick={handleClick}
                    >
                        <ScrollText
                            variant="V2.overline.neutral.bold"
                            data-testid={`${INCOGNITO_CART_DATA_TEST_IDS.TOP_BANNER.TEXT}-${index}`}
                            color="background_Primary"
                        >
                            {text}
                        </ScrollText>
                    </ScrollTextItem>
                ))}
            </ScrollContainer>
        </Wrapper>
    );
};

export default memo(VerticalScrollTextBanner);
